import { MuiMarkdown } from "mui-markdown";
import Heading from "../heading/Heading";
import ContentPanel from "../contentPanel/ContentPanel";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { getDatasetId, resolveAssetUrl } from "../../../utils/window-utils";
import { useAppSelector } from "../../../app/hooks";
import { selectSubmap } from "../../../app/configSlice";

const AboutPanel = () => {
  const { t, i18n } = useTranslation();
  const [aboutMarkdownContent, setAboutMarkdownContent] = useState("");
  const [prefixMarkdownContent, setPrefixMarkdownContent] = useState("");
  const submap = useAppSelector(selectSubmap);

  // Fetching the markdown to render in the about panel from the ui vocab
  // string t("about_content") - if this exists it overwrites the
  // non-localised about.md from the dataset.
  // This is a little messy to edit but means everything goes in config.json.
  // In future we might want to break this out into localised md files.
  const hasAboutContentInConfig = i18n.exists("about_content");

  useEffect(() => {
    if (!hasAboutContentInConfig) {
      fetch(`${import.meta.env.VITE_API_URL}/dataset/${getDatasetId()}/about`)
        .then((response) => response.text())
        .then((text) => {
          console.log("About content", text);
          setAboutMarkdownContent(text);
        });
    }
  });

  // An active submap can prepend its own markdown above the standard about
  // content, without replacing it
  useEffect(() => {
    const prefixUrl = resolveAssetUrl(submap?.aboutPrefix);
    if (!prefixUrl) return;
    fetch(prefixUrl)
      .then((response) => (response.ok ? response.text() : ""))
      .then(setPrefixMarkdownContent)
      .catch((error) => {
        console.error("Error fetching submap about prefix", error);
      });
  }, [submap?.aboutPrefix]);

  const content = hasAboutContentInConfig
    ? t("about_content")
    : aboutMarkdownContent;
  return (
    <>
      <Heading title={t("about")} />
      <ContentPanel>
        {prefixMarkdownContent && (
          <MuiMarkdown>{prefixMarkdownContent}</MuiMarkdown>
        )}
        <MuiMarkdown>{content}</MuiMarkdown>
      </ContentPanel>
    </>
  );
};

export default AboutPanel;
